<template>
  <div class="smart_container">
    <div class="smart-search" :class="{ 'search-active': _searchActive }">
      <button type="button" :class="{ 'd-none': isRecording }">
        <i class="fi fi-br-search"></i>
      </button>
      <div id="bars" :class="{ 'd-none': !isRecording }">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
      </div>
      <input
        type="text"
        placeholder="Search products, brands or categories"
        v-model="searchInput"
        data-toggle="dropdown"
      />
      <VoiceWidget
        @onresult="showTranscript"
        @unsupported="showVoiceUnsupported"
        @recordingStarted="
          () => {
            isRecording = true;
          }
        "
        @recordingEnded="
          () => {
            isRecording = false;
          }
        "
        @recordingFinished="
          () => {
            isRecording = false;
          }
        "
      />

      <button type="button" @click="toggleFilePanel">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          fill="currentColor"
          class="bi bi-camera"
          viewBox="0 0 16 16"
        >
          <path d="M10.5 8.5a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0" />
          <path
            d="M2 4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2h-1.172a2 2 0 0 1-1.414-.586l-.828-.828A2 2 0 0 0 9.172 2H6.828a2 2 0 0 0-1.414.586l-.828.828A2 2 0 0 1 3.172 4zm.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m9 2.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0"
          />
        </svg>
        <input
          id="myFileInput"
          type="file"
          accept="image/*"
          capture="camera"
          style="display: none"
          onchange="openCamera"
          ref="cams"
        />
      </button>
    </div>
    <div
      class="drop_bottom"
      v-show="_searchActive"
      :class="{ 'border-t-unset': _searchActive }"
    >
      <div>
        <ul
          class="search-results"
          v-if="searchResults && !searching && searchResults.length"
        >
          <li
            v-for="item in searchResults"
            :key="item.id"
            @click="$router.push(`${item.url}`)"
          >
            <router-link :to="`${item.url}`" class="pl-3">
              {{ item.name }}
            </router-link>
            <small class="pr-3">
              {{ item.category }}
            </small>
          </li>
        </ul>
        <p v-else class="pb-2 px-3">
          <span v-if="!searchResults && searching">
            Searching for {{ searchInput || "similar products" }}...
          </span>

          <span v-else>
            Sorry! We searched really hard but we could not find that product
            <strong>
              {{ searchInput ? `for ${searchInput}` : "matching that image" }}
            </strong>
          </span>
        </p>
      </div>
    </div>
    <div class="file-chooser" :class="{ 'd-none': !file_panel }">
      <vue-dropzone
        ref="imgArea"
        id="dropzone"
        :options="{
          url: `${baseURL}products/search`,
          thumbnailWidth: 150,
          maxFiles: 1,
          paramName: 'image',
          acceptedFiles: 'image/png, image/jpg',
        }"
        @vdropzone-sending="searchingByImage"
        @vdropzone-success="imageSearchResult"
        @vdropzone-error="imageUploadError"
      ></vue-dropzone>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { computed, ref, watch } from "vue";
import axios from "axios";
import VoiceWidget from "@/components/widgets/VoiceWidget.vue";
import { fail } from "@/lib/toast";

const baseURL = ref(process.env.VUE_APP_BASE_URL);
const searchInput = ref("");
const searchResults = ref(null);
const isRecording = ref(false);
const file_panel = ref(false);
const searching = ref(false);
const nextSearchResult = ref(null);
const imgArea = ref();

// eslint-disable-next-line no-unused-vars
watch(searchInput, async (query) => {
  if (query.length >= 3) {
    searching.value = true;

    await axios.post("products/search", { search_text: query })
              .then(result => result.data)
              .then(response => {
                searchResults.value = response.data;
                
                nextSearchResult.value = response.next_page_url;
              })
              .catch(e => {
                fail(e.message);
              })
              .finally(() => { searching.value = false });
  } else {
    searching.value = false;

    searchResults.value = null;
  }
});

const _searchActive = computed(() => searching.value || searchResults.value);

const showTranscript = (e) => {
  searchInput.value = e.transcript;
}

const showVoiceUnsupported = () => {
  fail('Your browser does not support this feature, please update your browser and try again.');
}

const toggleFilePanel = () => {
  file_panel.value = !file_panel.value;
  
  if(file_panel.value) {
    imgArea.value.removeAllFiles();
  }
};

const searchingByImage = (file, xhr, formData) => {
  toggleFilePanel();

  searching.value = true;
};

const imageSearchResult = (file, response) => {
};

const imageUploadError = (file) => {
  fail('Oops! An error occurred. Please try again');

  searching.value = false;
};
</script>

<style scoped>
.smart_container {
  position: relative;
}
.smart-search {
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #c9c9c9;
  padding: 0.2rem 1rem;
  border-radius: 25px;
}
.smart-search.search-active {
  border-bottom-left-radius: unset;
  border-bottom-right-radius: unset;
}
.smart-search input[type="text"] {
  flex: 1 1;
  padding: 0.4rem 1rem;
  border: none;
  outline: none;
}
.smart-search button {
  background-color: transparent;
  border: none;
  outline: none;
}
.m-visible {
  display: none;
}
.border-t-unset {
  border-top: unset !important;
}
.drop_bottom {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  position: absolute;
  z-index: 3;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: auto;
  text-align: center;
  padding: 0.5rem 0 0;
  background-color: white;
  border: 1px solid #c9c9c9;
}
.file-chooser {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  position: absolute;
  z-index: 3;
  width: 100%;
  height: auto;
  max-height: 200px;
  overflow: auto;
  text-align: center;
  padding: 1rem;
  background-color: white;
}
#bars {
  height: 25px;
  width: 12px;
  position: relative;
}
.bar {
  background: var(--primary-color);
  bottom: 1px;
  height: 3px;
  position: absolute;
  width: 3px;      
  animation: sound 0ms -800ms linear infinite alternate;
}
@keyframes sound {
  0% {
    opacity: .35;
    height: 3px; 
  }
  100% {
    opacity: 1;       
    height: 28px;
  }
}
.bar:nth-child(1) { left: 1px; animation-duration: 474ms; }
.bar:nth-child(2) { left: 5px; animation-duration: 433ms; }
.bar:nth-child(3) { left: 9px; animation-duration: 407ms; }
.bar:nth-child(4) { left: 13px; animation-duration: 458ms; }
.bar:nth-child(5) { left: 17px; animation-duration: 400ms; }
.bar:nth-child(6) { left: 21px; animation-duration: 427ms; }
.bar:nth-child(7) { left: 25px; animation-duration: 441ms; }
.bar:nth-child(8) { left: 29px; animation-duration: 419ms; }
.bar:nth-child(9) { left: 33px; animation-duration: 487ms; }
.bar:nth-child(10){ left: 37px; animation-duration: 442ms; }

.search-results {
  display: flex;
  flex-direction: column;
  margin-bottom: unset !important;
  align-items: flex-start;
}

.search-results > li {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;
  cursor: pointer;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.search-results > li:hover {
  background-color: #f1f1f1;
}

.search-results > li > a {
  color: #343a40;
  text-decoration: none;
  font-weight: 500;
}

.search-results > li > small {
  color: #767676;
  font-weight: 400;
}

@media (max-width: 990px) {
  .m-hidden {
    display: none;
  }
  .m-visible {
    display: unset;
    padding: unset;
    background: unset;
    margin: 0 0.5rem;
    cursor: pointer;
  }
}
</style>
